<template>
    
  <div class="injiaotong">
      
    <div class="head">
      <div class="title">{{ contentTitle }}</div>
      <div class="dibu">
        <div class="time">时间: {{ time }}</div>
        <div
          class="from"
          v-if="data.hasOwnProperty('source') && !data.source == ''"
        >
          来源：{{ data.source }}
        </div>
      </div>
    </div>
    <div class="share" @click="showShare" v-show="isZFB">
            <img src="../assets/images/shareBtn.png" alt="" />     
    </div>
     
    <van-popup
      v-model="isShowShare"
      round
      position="bottom"
      :style="{ height: 'auto' }"
    >
      <div class="shareWayList">
        <div class="everyShare" @click="shareWx">
          <div class="inEveryShare">
            <div class="shareIcon">
              <img src="../assets/images/weixinIcon.png" alt="" />
            </div>
            <div class="shareName">微信好友</div>
          </div>
        </div>
        <div class="everyShare" @click="shareWxfriend">
          <div class="inEveryShare">
            <div class="shareIcon">
              <img src="../assets/images/friendIcon.png" alt="" />
            </div>
            <div class="shareName">朋友圈</div>
          </div>
        </div>
        <div class="everyShare" @click="shareWeibo">
          <div class="inEveryShare">
            <div class="shareIcon">
              <img src="../assets/images/weiboIcon.png" alt="" />
            </div>
            <div class="shareName">微博</div>
          </div>
        </div>
        <div class="everyShare" @click="shareQQfriend">
          <div class="inEveryShare">
            <div class="shareIcon">
              <img src="../assets/images/qqIcon.png" alt="" />
            </div>
            <div class="shareName">QQ好友</div>
          </div>
        </div>

        <div class="everyShare twoEveryShare" @click="shareQzone">
          <div class="inEveryShare">
            <div class="shareIcon">
              <img src="../assets/images/qzoneIcon.png" alt="" />
            </div>
            <div class="shareName">QQ空间</div>
          </div>
        </div>
        <div class="everyShare" @click="refresh">
          <div class="inEveryShare">
            <div class="shareIcon">
              <img src="../assets/images/refreshIcon.png" alt="" />
            </div>
            <div class="shareName">刷新</div>
          </div>
        </div>
      </div>
      <div class="fenge"></div>
      <div class="dibuQuxiao" @click="noShare">
        <div class="word">取消</div>
      </div>
    </van-popup>
    <div class="content" v-html="content"></div>
  </div>
</template>

<script>
import Vue from "vue";
import { Swipe, SwipeItem } from "vant";
import { Field } from "vant";
import { Overlay } from "vant";
import { Popup } from "vant";
import qs from "qs";
import { Dialog } from "vant";
import bridge from "../common/bridge";
import { Toast } from "vant";
Vue.use(Popup);

Vue.use(Overlay);

Vue.use(Field);

Vue.use(Swipe);
Vue.use(SwipeItem);
export default {
  mounted() {
    this.getApp();
    this.getInjiaotongContent();

    this.src =
      this.$axios.defaults.baseURL +
      "llt-app-html" +
      "/InjiaotongShare" +
      `?contentId=${this.$route.query.contentId}`;
    document.querySelector("html").removeAttribute("style");
    // this.isZFB=false
  },
  created() {
    if (this.$route.query.title == "鹿路通使用指引") {
      document.title = "鹿路通使用指引";
      console.log(document);
    }
  },
  data() {
    return {
      isShowShare: false,
      content: "",
      title: "",
      neirong: "一个App畅享全市政务服务",
      src: "",
      type1: "wxhy",
      type2: "wxpyq",
      type3: "wb",
      type4: "qqhy",
      type5: "qqkj",
      contentTitle: "",
      time: "",
      from: "",
      data: Object,
      isZFB: true,
      readTask: {},
      shareTasK: {},
      credit: -1,
    };
  },
  methods: {
    async getTaskStatus() {
      Toast.loading({
        message: "请等待...",
        forbidClick: true,
      });
      let params = new URLSearchParams();
      params.append("columnCode", "RCRW");
      let taskRes = await this.$axios
        .post("/creditcenter/user/getUserCreditColumnTasklist", params)
        .catch((err) => {
          Toast.clear();
          console.error(err);
          Dialog.alert({
            message: "接口调用失败",
          }).then(() => {});
          return;
        });
      Toast.clear();
      let { result, reason, data } = taskRes.data;
      if (result !== 1) {
        Dialog.alert({
          message: reason,
        }).then(() => {});
        return;
      }
      data.list.forEach((item) => {
        if (item.taskId === "22102010053391107663") this.readTask = { ...item };
        if (item.taskId === "22102010061837406359")
          this.shareTasK = { ...item };
      });
      console.log(this.readTask, this.shareTasK);
    },

    addIntegral(creditDesc, type) {
      // 分享添加积分
      console.log("触发分享", creditDesc);

      this.$apis.CmsInterface.addIntegral(this.$axios, {
        type,
        creditDesc,
      }).then((res) => {
        let { result = 1, creditTaskInfo } = res.data;

        let ua = navigator.userAgent;
        let isiOS = !!ua.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);

        if (isiOS) {
          bridge.registerhandler("shareEnd", (data) => {
            if (result !== 1) {
              return;
            }

            if (creditTaskInfo.state === 0) {
              return;
            }

            let params = {
              credit: "+" + creditTaskInfo.credit,
              taskName: "分享文章",
            };
            bridge.callhandler(
              "showIntergralToast",
              JSON.stringify(params),
              (data) => {
                console.log(data);
              }
            );
          });
        } else {
          window["shareEnd"] = function () {
            if (result !== 1) {
              return;
            }

            if (creditTaskInfo.state === 0) {
              return;
            }

            window.ServiceAddrInterface.showIntergralToast(
              "分享文章",
              "+" + creditTaskInfo.credit
            );
          };
        }
      });
    },
    getApp() {
      let ua = navigator.userAgent;
      if (
        ua.indexOf("AliApp") > -1 ||
        ua.toLowerCase().match(/MicroMessenger/i) == "micromessenger"
      ) {
        this.isZFB = false;
      } else {
        this.$apis.CmsInterface.addIntegral(this.$axios, {
          type: 1,
          creditDesc: "阅读-交通出行",
        }).then((res) => {
          let { result, creditTaskInfo } = res.data;
          if (result !== 1 || creditTaskInfo.state === 0) {
            return;
          }
          let ua = navigator.userAgent;
          let isiOS = !!ua.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);

          if (isiOS) {
            let params = {
              credit: "+" + creditTaskInfo.credit,
              taskName: "阅读文章",
            };
            bridge.callhandler(
              "showIntergralToast",
              JSON.stringify(params),
              (data) => {
                console.log(data);
              }
            );
          } else {
            window.ServiceAddrInterface.showIntergralToast(
              "阅读文章",
              "+" + creditTaskInfo.credit
            );
          }
        });
      }
    },
    getYMDHMS(timestamp) {
      let time = new Date(timestamp);
      let year = time.getFullYear();
      let month = time.getMonth() + 1;
      let date = time.getDate();
      let hours = time.getHours();
      let minute = time.getMinutes();
      let second = time.getSeconds();

      if (month < 10) {
        month = "0" + month;
      }
      if (date < 10) {
        date = "0" + date;
      }
      if (hours < 10) {
        hours = "0" + hours;
      }
      if (minute < 10) {
        minute = "0" + minute;
      }
      if (second < 10) {
        second = "0" + second;
      }
      return year + "-" + month + "-" + date;
    },

    shareWx() {
      let ua = navigator.userAgent;
      let isAndroid = ua.indexOf("Android") > -1 || ua.indexOf("Adr") > -1;
      let isiOS = !!ua.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
      let data = {
        src: this.src,
        title: this.contentTitle,
        content: this.neirong,
        type: this.type1,
      };

      let data2 = JSON.stringify(data);

      if (isiOS) {
        bridge.callhandler("shareMessage", data2, (data) => {
          console.log(data);
        });
        this.addIntegral("微信-分享" + "-交通出行", 2);
      }
      if (isAndroid) {
        // var str = JSON.parse(
        window.ServiceAddrInterface.shareMessage(
          this.src,
          this.contentTitle,
          this.neirong,
          this.type1
        );
        // );
        // console.log(window)
        this.addIntegral("微信-分享" + "-交通出行", 2);
      }
    },
    shareWxfriend() {
      let ua = navigator.userAgent;
      let isAndroid = ua.indexOf("Android") > -1 || ua.indexOf("Adr") > -1;
      let isiOS = !!ua.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
      let data = {
        src: this.src,
        title: this.contentTitle,
        content: this.neirong,
        type: this.type2,
      };

      let data2 = JSON.stringify(data);
      if (isiOS) {
        bridge.callhandler("shareMessage", data2, (data) => {
          // 处理返回数据
          console.log(data);
        });
        this.addIntegral("朋友圈-分享" + "-交通出行", 2);
      }
      if (isAndroid) {
        // var str = JSON.parse(
        window.ServiceAddrInterface.shareMessage(
          this.src,
          this.contentTitle,
          this.neirong,
          this.type2
        );
        // );
        this.addIntegral("朋友圈-分享" + "-交通出行", 2);
      }
    },
    shareWeibo() {
      let ua = navigator.userAgent;
      let isAndroid = ua.indexOf("Android") > -1 || ua.indexOf("Adr") > -1;
      let isiOS = !!ua.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
      let data = {
        src: this.src,
        title: this.contentTitle,
        content: this.neirong,
        type: this.type3,
      };
      let data2 = JSON.stringify(data);
      if (isiOS) {
        bridge.callhandler("shareMessage", data2, (data) => {
          // 处理返回数据
          console.log(data);
        });
        this.addIntegral("微博-分享" + "-交通出行", 2);
      }
      if (isAndroid) {
        // var str = JSON.parse(
        window.ServiceAddrInterface.shareMessage(
          this.src,
          this.contentTitle,
          this.neirong,
          this.type3
        );
        // );
        this.addIntegral("微博-分享" + "-交通出行", 2);
      }
    },
    shareQQfriend() {
      let ua = navigator.userAgent;
      let isAndroid = ua.indexOf("Android") > -1 || ua.indexOf("Adr") > -1;
      let isiOS = !!ua.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
      let data = {
        src: this.src,
        title: this.contentTitle,
        content: this.neirong,
        type: "qq",
      };
      let data2 = JSON.stringify(data);
      if (isiOS) {
        bridge.callhandler("shareMessage", data2, (data) => {
          // 处理返回数据
          console.log(data);
        });
        this.addIntegral("qq好友-分享" + "-交通出行", 2);
      }
      if (isAndroid) {
        // var str = JSON.parse(
        window.ServiceAddrInterface.shareMessage(
          this.src,
          this.contentTitle,
          this.neirong,
          this.type4
        );
        // );
        this.addIntegral("qq好友-分享" + "-交通出行", 2);
      }
    },
    shareQzone() {
      let ua = navigator.userAgent;
      let isAndroid = ua.indexOf("Android") > -1 || ua.indexOf("Adr") > -1;
      let isiOS = !!ua.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
      let data = {
        src: this.src,
        title: this.contentTitle,
        content: this.neirong,
        type: this.type5,
      };
      let data2 = JSON.stringify(data);
      if (isiOS) {
        bridge.callhandler("shareMessage", data2, (data) => {
          // 处理返回数据
          console.log(data);
        });
        this.addIntegral("qq空间-分享" + "-交通出行", 2);
      }
      if (isAndroid) {
        // var str = JSON.parse(
        window.ServiceAddrInterface.shareMessage(
          this.src,
          this.contentTitle,
          this.neirong,
          this.type5
        );
        // );
        this.addIntegral("qq空间-分享" + "-交通出行", 2);
      }
    },
    refresh() {
      location.reload();
    },
    getInjiaotongContent() {
      this.$toast.loading({
        message: "信息获取中...",
        forbidClick: true,
      });
      let params = qs.stringify({
        metacode: "TRANSPORTATION",
        id: this.$route.query.contentId,
      });
      console.log(this.$route);

      this.$axios
        .post("appapi/cmsInterface/getCmsInfo", params)
        .then((res) => {
          if (res.data.result !== 1) {
            Toast.clear();
            Dialog.alert({
              message: res.data.reason,
            }).then(() => {});
            return;
          }
          if (res.data.result === 1) {
            this.content = res.data.data.content;
            this.contentTitle = res.data.data.title;
            res.data.data.pubtime = this.getYMDHMS(res.data.data.pubtime);
            this.time = res.data.data.pubtime;
            this.data = res.data.data;
            if (this.contentTitle == "鹿路通使用指引") {
              console.log(res.data.data.title);
              console.log(document.title);
              document.title = "鹿路通使用指引";
              console.log(document.title);
            }
            Toast.clear();
          }
        })
        .catch((err) => {
          Toast.clear();
          console.error(err);
          Dialog.alert({
            message: "接口调用失败",
          }).then(() => {});
          return;
        });
    },
    showShare() {
      this.isShowShare = true;
    },
    noShare() {
      this.isShowShare = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.content {
  padding: 0 15px !important;
}

.content ::v-deep img {
  width: 330px;
  height: auto;
}

.injiaotong {
  background-color: #fff;
  min-height: 100vh;
}

.head {
  padding: 13px 16px 0 16px;

  .title {
    color: #19212a;
    font-size: 22px;
    line-height: 32px;
    font-weight: 500;
  }

  .dibu {
    display: flex;
    align-items: center;
    margin-top: 12px;
    padding-bottom: 11px;

    .time {
      color: #878787;
      font-size: 13px;
    }

    .from {
      color: #878787;
      font-size: 13px;
      margin-left: 1rem;
    }
  }
}

.share {
  width: 50px;
  height: 50px;
  background: #ffffff;
  box-shadow: 0px 0px 12px rgba(67, 219, 181, 0.25);
  position: fixed;
  bottom: 18px;
  right: 16px;
  border-radius: 2000px;
  display: flex;
  justify-content: center;
  align-items: center;

  img {
    width: 22px;
  }
}

.shareWayList {
  padding: 0 8px 12px 8px;
  display: flex;
  flex-wrap: wrap;

  .everyShare {
    width: 25%;
    display: flex;
    justify-content: center;
    margin-top: 24px;

    .shareIcon {
      img {
        width: 52px;
      }
    }

    .shareName {
      color: #555555;
      font-size: 13px;
      margin-top: 8px;
      text-align: center;
    }
  }
}

.fenge {
  width: 100%;
  height: 10px;
  background: #eef4f6;
}

.dibuQuxiao {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 51px;

  .word {
    color: #19212a;
    font-size: 16px;
  }
}

.content {
  margin-bottom: 150px;
}
</style>

